export default function supabaseLoader({ src, width, quality }) {
  if (src.includes('supabase.co')) {
    return `${src.replace('object', 'render/image')}?width=${width}&quality=100&resize=contain`;
  }
  return `${src}?w=${width}&q=${quality || 75}`;
}
